import * as React from 'react';
import * as main from "../../main.module.scss";
import * as gift from "./style.module.scss";
export const Gift = () => {
  return (
    <section className={gift.gift}>
      <div className="container">
        <div className={gift.container}>
          <div className={gift.info}>
            <h2>Подарок за регистрацию</h2>
            <p>20 нейроупражнений для развития мозга ребёнка</p>
            <ul>
              <li>Улучшите мелкую моторику;</li>
              <li>Улучшите межполушарное взаимодействие;</li>
              <li>Подготовите мозг к интеллектуальной деятельности;</li>
              <li>Познакомитесь с нашим эксклюзивным подходом к саморазвитию.</li>
            </ul>
            <a className={main.btn} href={"#reg"}>Зарегистрироваться</a>
            <div className={gift.edm}>
              <p>Подарок за&nbsp;участие в&nbsp;вебинаре:</p>
              <p>«Энциклопедия детской мотивации»</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
